import { TFunction } from 'i18next';

/**
 * All roles are based on the roles from Skopei Connect.
 *
 * TODO: Add role descriptions
 */
enum UserRoleEnum {
	// Backend roles
	AllowAnonymous = 'AllowAnonymous',
	Manufacturing = 'Manufacturing',
	ClientAdmin = 'ClientAdmin',
	User = 'User',
	SuperAdmin = 'SuperAdmin',
	Support = 'Support',
}

export function getUserRoleLabel(userRole: UserRoleEnum, t: TFunction): string {
	switch (userRole) {
		case UserRoleEnum.AllowAnonymous:
			return t('user.roles.allowAnonymous', { ns: 'entities' });
		case UserRoleEnum.Manufacturing:
			return t('user.roles.manufacturing', { ns: 'entities' });
		case UserRoleEnum.ClientAdmin:
			return t('user.roles.clientAdmin', { ns: 'entities' });
		case UserRoleEnum.User:
			return t('user.roles.user', { ns: 'entities' });
		case UserRoleEnum.SuperAdmin:
			return t('user.roles.superAdmin', { ns: 'entities' });
		case UserRoleEnum.Support:
			return t('user.roles.support', { ns: 'entities' });
		default:
			return t('general.unknown', { ns: 'entities' });
	}
}

export default UserRoleEnum;
